module.exports = __webpack_public_path__ + "img/logo.831a0225.png";